import React from 'react'

const UserActivityDetails = () => {
  return (
    <div>
        User activity details pending
    </div>
  )
}

export default UserActivityDetails
